<script setup lang="ts">
const props = defineProps<{
  isRoletasPage: boolean;
}>();

const { isGameModalOpen } = storeToRefs(useCasinoStore());
const { isSportsPage } = useSportsBook();
const { isCactusSportsbookEnabled } = useFeatureFlagsEnv();
const { bottomMenu } = storeToRefs(useLayoutStore());
const { isWithinMigrationPeriod } = useFeatureFlagsNew();
const { isFooterV2Enabled } = useFeatureFlagsJson();

const bottomMenuHeight = computed(() => {
  const bottomMenuHeight = bottomMenu.value.height;

  return bottomMenuHeight ? `${bottomMenuHeight + 50}px` : '50px';
});

const isHideFooter = computed(() => {
  return isSportsPage.value && isCactusSportsbookEnabled.value;
});
</script>

<template>
  <footer
    v-if="!isHideFooter"
    id="divPageFooter"
    class="footer"
    :class="[
      { hidden: isGameModalOpen },
      props.isRoletasPage ? 'bg-black' : 'bg-[#FFFFFF1A]',
      { '!pt-0 !px-0 !border-t-0 lg:!pb-0': isFooterV2Enabled },
    ]"
  >
    <FooterV2 v-if="isFooterV2Enabled" />

    <template v-else>
      <FooterInfoSection v-if="!isWithinMigrationPeriod" />
      <FooterLinksMigration v-else-if="!isBetBr()" />

      <FooterPatronages v-if="!isWithinMigrationPeriod" />

      <FooterTextToggle v-if="!isWithinMigrationPeriod" />
      <FooterBrazilians v-if="!isWithinMigrationPeriod" />

      <FooterRegister />
      <FooterSeals />

      <FooterEmails v-if="!isWithinMigrationPeriod" />

      <FooterCasinoAuth />
    </template>
  </footer>
</template>

<style scoped lang="scss">
.footer {
  @apply relative z-[9] border-solid border-t border-footer-links/30 bg-footer-bg-primary w-full py-4 px-4 lg:px-6;

  padding-bottom: v-bind(bottomMenuHeight);

  @apply lg:pb-[70px];

  ::v-deep(.footer-title) {
    @apply font-bold mb-2 text-footer-titles text-sm lg:text-base whitespace-nowrap;
  }

  .footer-section {
    @apply relative py-6 first:pt-0 lg:first:pt-6 flex justify-center lg:justify-between items-center flex-wrap lg:flex-nowrap gap-2 md:gap-3;
    &:after {
      @apply w-full h-px bg-footer-texts absolute top-full left-0 opacity-15;
      content: '';
    }
  }
}
</style>
